//化成菜单树
function toTree(data){
    let cloneData = JSON.parse(JSON.stringify(data))    // 对源数据深度克隆
    return cloneData.filter( father => {
        let branchArr = cloneData.filter(child => father.id === child.parentId)    //返回每一项的子级数组
        branchArr.length > 0 ? father.children = branchArr : ''   //如果存在子级，则给父级添加一个children属性，并赋值
        return father.parentId === null || father.parentId === '' || father.parentId === 0 || father.parentId === undefined;      //返回第一层
    });
}
export default {
    toTree(data){
        return toTree(data);
    }
}
